<template>
  <div class="nav-drawer">
    <v-navigation-drawer
      style="z-index: 1000000"
      v-model="drawer"
      location="right"
      temporary
      :width="props.windowWidth < 767 ? props.windowWidth / 2 : 370"
      class="pr-2 pl-3"
    >
      <div
        class="px-0"
        elevation="0"
        style="overflow: hidden; max-height: 400px"
      >
        <v-card-title
          style="font-size: 17px; font-weight: bold; margin-top: -10px"
          class="text-drawer d-flex align-center justify-space-between"
        >
          Shopping Cart
          <v-hover v-slot:default="{ isHovering, props }">
            <div v-bind="props">
              <v-icon
                @click="drawer = false"
                style="font-size: 35px"
                :color="isHovering ? 'blue' : 'black'"
              >
                mdi-share-outline
              </v-icon>
            </div>
          </v-hover>
        </v-card-title>
        <v-card-text style="color: #6f6f6f">
          {{ cardItem.length }} Items
        </v-card-text>
        <v-card-text
          class="px-0"
          style="color: #6f6f6f; margin-top: -25px"
          v-if="cardItem.length && totalPrice < 10000"
        >
          Only {{ 10000 - totalPrice }} $ away from Free Shipping
        </v-card-text>

        <v-card-text
          class="px-0"
          style="color: green; margin-top: -25px"
          v-if="cardItem.length && totalPrice >= 10000"
        >
          A discount of $1000 was made
          <v-icon color="green">mdi-check-outline</v-icon>
        </v-card-text>

        <div class="bar-parent" style="position: relative">
          <v-progress-linear
            v-if="cardItem.length"
            :color="
              totalPrice < 3000
                ? 'red'
                : totalPrice < 5000
                ? 'yellow'
                : totalPrice < 8000
                ? 'blue'
                : 'green'
            "
            height="10"
            :model-value="(totalPrice / 10000) * 100"
            striped
          >
          </v-progress-linear>
        </div>
        <v-card-text
          v-if="!cardItem.length"
          class="px-0 text-center"
          style="color: #6f6f6f"
        >
          Your cart is empty.
        </v-card-text>
        <v-card-actions v-if="!cardItem.length">
          <v-btn
            @click="drawer = false"
            style="
              text-transform: none;
              border-radius: 30px;
              border-color: rgb(199, 199, 199);
            "
            class="w-100"
            variant="outlined"
            density="compact"
            height="45"
          >
            Continue Shopping
          </v-btn>
        </v-card-actions>
      </div>

      <v-card
        class="pa-0 mt-4"
        elevation="0"
        style="max-height: 230px; overflow-y: auto"
      >
        <v-container class="px-0">
          <v-row v-for="item in cardItem" :key="item.id" class="align-center">
            <v-col cols="12" sm="5">
              <img
                :src="item.thumbnail ? item.thumbnail : item.image"
                class="w-100 imge-drawer"
                alt=""
              />
            </v-col>
            <v-col cols="12" sm="7">
              <v-card-title
                class="px-0"
                style="white-space: pre-wrap; font-size: 14px; line-height: 1.2"
              >
                {{ item.title }} Sample - {{ item.category }}
              </v-card-title>
              <v-card-text class="px-0" style="color: #6f6f6f">
                Category: {{ item.category }}
              </v-card-text>
              <v-card-text class="py-3">
                <span style="font-size: 16px; font-weight: 900; color: #ff0000">
                  {{
                    item.discountPercentage
                      ? Math.ceil(
                          item.price -
                            item.price * (item.discountPercentage / 100)
                        ) * item.quantity
                      : item.price
                  }}$
                </span>
              </v-card-text>
            </v-col>

            <v-container
              class="text-center d-flex align-center justify-space-around"
              style="margin-top: -20px"
            >
              <div class="price">
                <div
                  class="counter px-1"
                  style="
                    border-radius: 30px;
                    border: 1px solid rgb(201, 201, 201);
                    width: fit-content;
                    margin: auto;
                  "
                >
                  <v-icon
                    @click="item.quantity > 1 ? item.quantity-- : false"
                    size="22"
                    >mdi-minus</v-icon
                  >
                  <input
                    type="number"
                    style="outline: none; width: 60px; font-size: 13px"
                    min="1"
                    v-model="item.quantity"
                    class="text-center py-2"
                  />
                  <v-icon @click="item.quantity++" size="22">mdi-plus</v-icon>
                </div>
              </div>
              <v-hover v-slot="{ isHovering, props }">
                <div
                  v-bind="props"
                  style="display: inline-block; cursor: pointer"
                >
                  <v-icon
                    @click="deleteItem(item.id)"
                    :color="isHovering ? 'red' : 'black'"
                    style="transition: color 0.2s"
                  >
                    {{ isHovering ? "mdi-delete-empty" : "mdi-delete" }}
                  </v-icon>
                </div>
              </v-hover>
            </v-container>
            <v-divider class="mb-3"></v-divider>
          </v-row>
        </v-container>
      </v-card>

      <v-card elevation="0" v-if="cardItem.length" class="mt-3">
        <v-card-actions
          class="flex-column justify-center align-center"
          style="gap: 15px"
        >
          <v-btn
            @click="saveDataInLocal"
            style="
              text-transform: none;
              border-radius: 30px;
              border-color: rgb(199, 199, 199);
            "
            variant="elevated"
            density="compact"
            height="45"
            class="w-100"
            elevation="0"
            color="blue"
          >
            Check Out
          </v-btn>
          <v-btn
            @click="goToCart"
            style="
              text-transform: none;
              border-radius: 30px;
              border-color: rgb(199, 199, 199);
            "
            variant="outlined"
            density="compact"
            height="45"
            class="w-100 mx-0"
          >
            View Cart
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>
<style lang="css">
@media (max-width: 480px) {
  .nav-drawer .text-drawer {
    font-size: 13px !important;
    margin-left: -13px;
  }
  .nav-drawer .imge-drawer {
    width: 80% !important;
  }
}
</style>

<script setup>
import { ref, inject, onMounted, computed, defineProps } from "vue";
import { cards } from "@/store/card";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
const router = useRouter();
const goToCart = () => {
  router.push({ name: "cartPage" });
};
const props = defineProps({
  windowWidth: Number,
});

const dataCard = cards();
const Emitter = inject("Emitter");
const drawer = ref(false);
const { cardItem } = storeToRefs(dataCard);

const deleteItem = dataCard.deleteItem;
const getNewData = dataCard.getNewData;

const saveDataInLocal = () => {
  getNewData();
  router.push({ name: "checkOut" });
};
onMounted(() => {
  Emitter.on("openCart", () => {
    drawer.value = true;
  });

  dataCard.getCardLocalStorage();
});

const calcPriceOver = () => {
  let total = 0;
  cardItem.value.forEach((product) => {
    if (product.price && product.quantity) {
      // تحقق من وجود السعر والكمية
      const discountedPrice = product.discountPercentage
        ? product.price - product.price * (product.discountPercentage / 100)
        : product.price;

      total += Math.ceil(discountedPrice * product.quantity);
    }
  });
  return total; // تأكد من إرجاع القيمة الإجمالية
};

const totalPrice = computed(() => calcPriceOver());
</script>
